import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcdbb106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, null, -1))
const _hoisted_3 = { class: "col-sm-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Address", -1))
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "C/o", -1))
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, [
  /*#__PURE__*/_createTextVNode("Address "),
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Line 1")
], -1))
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Address Line 2")
], -1))
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "City", -1))
const _hoisted_16 = { class: "col-sm-3" }
const _hoisted_17 = { class: "form-group row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "County", -1))
const _hoisted_19 = { class: "col-sm-3" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Postcode", -1))
const _hoisted_22 = { class: "col-sm-2" }
const _hoisted_23 = { class: "form-group row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Phone", -1))
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "form-group row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1))
const _hoisted_28 = { class: "col-sm-6" }

import { CustomerDictionary } from '@/models/customerdictionary.model';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'Address',
  setup(__props) {

const store = useStore();
const customerdictionary = computed(() => store.getters['customerdictionary/current'] as CustomerDictionary);

const setCustomerDictionaryDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('customerdictionary/setCustomerDictionaryDeep', payload);
};

const customerCo = computed({
  get: () => customerdictionary.value.customer.co,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.co", data }),
});

const customerAddressLine1 = computed({
  get: () => customerdictionary.value.customer.address.line1,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.address.line1", data }),
});

const customerAddressLine2 = computed({
  get: () => customerdictionary.value.customer.address.line2,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.address.line2", data }),
});

const customerAddressTown = computed({
  get: () => customerdictionary.value.customer.address.town,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.address.town", data }),
});

const customerAddressCounty = computed({
  get: () => customerdictionary.value.customer.address.county,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.address.county", data }),
});

const customerAddressPostcode = computed({
  get: () => customerdictionary.value.customer.address.postcode,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.address.postcode", data }),
});

const customerPhone = computed({
  get: () => customerdictionary.value.customer.address.phone,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.address.phone", data }),
});

const customerEmail = computed({
  get: () => customerdictionary.value.customer.address.email,
  set: (data: string) => setCustomerDictionaryDeep({ path: "customer.address.email", data }),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("fieldset", null, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerCo).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerCo.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerAddressLine1).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerAddressLine1.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customerAddressLine2).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerAddressLine2.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerAddressTown).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerAddressTown.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customerAddressCounty).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerAddressCounty.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customerAddressPostcode).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerAddressPostcode.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customerPhone).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerPhone.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customerEmail).value = $event))
            }, null, 512), [
              [
                _vModelText,
                customerEmail.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})